import { createSlice, type PayloadAction } from '@reduxjs/toolkit';


interface SettingsState {
  language: string;
  hapticsEnabled: boolean;
  /**
   * Banner ridotto per liberare spazio verticale.
   *
   * NON persistito, e non piu' una preferenza: e' la conseguenza dello scroll.
   * Salvarlo significherebbe riaprire l'app in stato compresso senza che nulla
   * sia stato scrollato — uno stato senza causa visibile, che l'utente non
   * saprebbe come annullare ora che il comando manuale non c'e' piu'.
   */
  bannerCompact: boolean;
}

const initialState: SettingsState = {
  language: 'en',
  hapticsEnabled: true,
  bannerCompact: false,
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setLanguage(state, action: PayloadAction<string>) {
      state.language = action.payload;
    },
    setHapticsEnabled(state, action: PayloadAction<boolean>) {
      state.hapticsEnabled = action.payload;
    },
    setBannerCompact(state, action: PayloadAction<boolean>) {
      state.bannerCompact = action.payload;
    },
  },
});

export const { setLanguage, setHapticsEnabled, setBannerCompact } = settingsSlice.actions;
export default settingsSlice.reducer;
